import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export interface INavLinkProps {
  icon: React.ReactNode;
  title: string;
  link: string;
  isActive?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  special?: boolean;
  openInNewTab?: boolean;
  notification?: number;
}

export const NavLink: React.FC<INavLinkProps> = ({ icon, title, link, isActive, onClick, disabled, openInNewTab, notification, special }) => {
  const { t } = useTranslation();

  return (
    <Link
      to={!disabled ? link : '#'}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
        } else if (onClick) {
          onClick();
        }
      }}
      target={openInNewTab ? '_blank' : undefined}
      rel={openInNewTab ? 'noopener noreferrer' : undefined}
    >
      <div
        className={classNames([
          'flex flex-row mt-5 rounded-2xl text-primary-900 px-3 py-3 duration-150 ease-in-out items-center hover:bg-[#FF6346]',
          isActive ? 'text-white bg-primary' : 'text-black hover:text-white',
          disabled && 'cursor-not-allowed opacity-50',
          special && 'border border-primary'
        ])}
        id="menu"
      >
        <div className="mr-3">{icon}</div>
        <p className="font-semibold">{t(`navMenu.${title}`)}</p>
        {notification && (
          <div className="bg-red-600 text-white absolute right-10 rounded-full text-xs items-center flex justify-center h-6 w-6">{notification}</div>
        )}
      </div>
    </Link>
  );
};
